// Translation for it
export const it = {
        common: {
            save: 'Salva',
            cancel: 'Annulla',
            close: 'Chiudi',
            delete: 'Elimina',
            edit: 'Modifica',
            activate: 'Attiva',
            add: 'Aggiungi',
            saving: 'Salvataggio...',
            loading: 'Caricamento...',
            active: 'ATTIVO',
            inUse: 'In uso',
            test: 'Test',
            searchApps: 'Cerca app...',
            betaBanner: 'BETA - Servizio non ancora disponibile!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Accedi',
            signUp: 'Registrati',
            username: 'Nome utente',
            password: 'Password',
            continue: 'Continua',
            noAccount: 'Non hai un account?',
            hasAccount: 'Hai già un account?',
            loginError: 'Accesso non riuscito',
            invalidCredentials: 'Nome utente o password non validi',
            rateLimited: 'Troppi tentativi di accesso. Attendi un momento.',
            sessionExpired: 'La tua sessione è scaduta. Usa un nuovo link magico.',
            magicLinkInvalid: 'Il link di accesso è non valido o scaduto.',
            magicLinkSuccess: 'Benvenuto! Sei stato accesso con successo.',
            magicLinkProcessing: 'Elaborazione dell\'accesso...',
            connectionError: 'Errore di connessione. Riprova.'
        },
        profile: {
            myProgress: 'Il Mio Progresso di Apprendimento',
            signOut: 'Esci',
            plan: 'Piano: '
        },
        settings: {
            title: 'Impostazioni',
            tabs: {
                uiSettings: 'Impostazioni UI',
                systemPrompt: 'Prompt di Sistema',
                llmProfiles: 'Profili LLM',
                ttsProfiles: 'Profili TTS',
                language: 'Lingua',
            },
            uiSettings: {
                title: 'Interfaccia Utente',
                themeMode: 'Modalità Tema',
                darkMode: 'Modalità Scura',
                lightMode: 'Modalità Chiara',
                themeColor: 'Colore del Tema',
                themeColorDesc: 'Scegli il colore di accento per pulsanti, icone e evidenziazioni',
                background: 'Sfondo',
                backgroundDesc: 'Scegli uno sfondo per il tuo spazio di lavoro',
                selectBackgroundColor: 'Seleziona Colore di Sfondo',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Concentrazione',
                    concentration: 'Focus',
                    relaxation: 'Rilassamento',
                    lianas: 'Liane',
                    color: 'Colore'
                },
                backgroundColors: {
                    deepDark: 'Nero Profondo',
                    darkGrey: 'Grigio Scuro',
                    midnightBlue: 'Blu Mezzanotte',
                    indigo: 'Indaco',
                    darkTeal: 'Verde Acqua Scuro',
                    brown: 'Marrone',
                    darkRed: 'Rosso Scuro',
                    deepPurple: 'Viola Profondo',
                    pureWhite: 'Bianco Puro',
                    softWhite: 'Bianco Morbido',
                    lightGrey: 'Grigio Chiaro',
                    paleBlue: 'Blu Pallido',
                    paleGreen: 'Verde Pallido',
                    paleOrange: 'Arancione Pallido',
                    lavender: 'Lavanda',
                    blueGrey: 'Blu Grigio'
                }
            },
            systemPrompt: {
                label: 'Prompt di Sistema:',
                placeholder: 'Caricamento prompt di sistema...',
                emptyError: 'Il prompt di sistema non può essere vuoto!',
                saveSuccess: '✓ Prompt di sistema salvato con successo!',
                loadError: 'Errore durante il caricamento del prompt di sistema',
                saveError: 'Errore durante il salvataggio'
            },
            llmProfiles: {
                addButton: '+ Aggiungi Nuova Connessione',
                newConnection: 'Nuova Connessione',
                editConnection: 'Modifica Connessione',
                emptyState: 'Nessuna connessione LLM disponibile. Fai clic sotto per aggiungerne una.',
                loadingProfiles: 'Caricamento profili...',
                nameLabel: 'Nome *',
                namePlaceholder: 'es. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Chiave API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modello *',
                modelPlaceholder: 'gpt-4, mistral-tiny, ecc.',
                allFieldsRequired: 'Tutti i campi devono essere compilati!',
                saveSuccess: '✓ Profilo salvato con successo!',
                deleteConfirm: 'Vuoi veramente eliminare "{name}"?',
                profileNotFound: 'Profilo non trovato!',
                loadError: 'Errore durante il caricamento dei profili',
                saveError: 'Errore durante il salvataggio',
                activateError: 'Errore durante l\'attivazione',
                deleteError: 'Errore durante l\'eliminazione',
                modelInfo: 'Modello: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Aggiungi Nuova Voce',
                newVoice: 'Nuova Voce',
                editVoice: 'Modifica Voce',
                emptyState: 'Nessun profilo TTS disponibile. Fai clic sotto per aggiungerne uno.',
                loadingProfiles: 'Caricamento profili TTS...',
                nameLabel: 'Nome',
                namePlaceholder: 'es. Il Mio ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'es. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Locale)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Chiave API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modello *',
                modelIdPlaceholder: 'es. eleven_monolingual_v1',
                voiceIdLabel: 'ID Voce',
                voiceIdPlaceholder: 'es. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Tutti i campi devono essere compilati!',
                saveSuccess: '✓ Profilo TTS salvato con successo!',
                deleteConfirm: 'Vuoi veramente eliminare "{name}"?',
                loadError: 'Errore durante il caricamento dei profili TTS',
                saveError: 'Errore durante il salvataggio',
                activateError: 'Errore durante l\'attivazione',
                deleteError: 'Errore durante l\'eliminazione'
            },
            language: {
                title: 'Scegli Lingua',
                description: 'Seleziona la tua lingua preferita per l\'interfaccia utente'
            },
        },
        chat: {
            ready: 'Pronto',
            start: 'INIZIA',
            stop: 'FERMA',
            initialMessage: 'Fai clic su INIZIA per una conversazione in tempo reale.',
            listening: 'In ascolto...',
            speaking: 'Thorsten sta parlando...',
            userLabel: 'Tu',
            aiLabel: 'IA',
            modalTitle: 'Chat IA Thorsten',
            inputPlaceholder: 'Digita un messaggio...',
            send: 'Invia',
            loginRequired: 'Accedi per usare questo servizio.',
            loginButton: 'Accedi Ora',
            magicLinkRequired: 'Usa un link magico per accedere.',
            creditLimitError: 'La tua quota oraria è esaurita. Aggiorna il tuo piano (Medium/Premium) per continuare.',
            serviceDisabled: 'Il servizio di chat non è attualmente disponibile. Riprova più tardi.'
        },
        notifications: {
            error: 'Errore',
            success: 'Successo',
            info: 'Informazione',
            unknownError: 'Si è verificato un errore sconosciuto'
        },
        cookie: {
            message: 'Questo sito web utilizza i cookie per offrirti la migliore esperienza utente possibile.',
            accept: 'Accetta'
        },
        curriculum: {
                buttonLabel: 'Curriculum',
                buttonTitle: 'Mostra contenuto del curriculum',
                modalTitle: 'Curriculum di {app}',
                sections: {
                    topic: 'Argomento del curriculum',
                    explanation: 'Spiegazione per bambini',
                    studentProfile: 'Profilo studente'
                },
                topic: {
                    empty: 'Nessun argomento del curriculum è collegato a questa micro-app nel backend.',
                    missingDetail: 'I dati dettagliati del curriculum per questa micro-app non sono ancora disponibili nel backend.',
                    learningGoals: 'Obiettivi di apprendimento',
                    prerequisites: 'Prerequisiti',
                    unitLabel: 'Unità',
                    durationLabel: 'Durata',
                    difficultyLabel: 'Difficoltà',
                    hours: 'h',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Nessuna spiegazione per bambini disponibile.',
                    loadingPrepare: 'L\'IA sta preparando la spiegazione',
                    loadingExplain: 'L\'IA sta spiegando l\'argomento in linguaggio per bambini',
                    requestFailed: 'Impossibile generare una spiegazione per bambini.'
                },
                studentProfile: {
                    country: 'Paese',
                    region: 'Stato / Regione',
                    schoolType: 'Tipo di scuola',
                    grade: 'Classe',
                    noContext: 'Nessun contesto studente disponibile.',
                    childProfileNotFound: 'Nessun profilo studente trovato nel backend per l\'accesso corrente.',
                    loginProfileIncomplete: 'Il profilo di accesso non contiene ancora un contesto studente completo.',
                    educationContextNotFound: 'È stato trovato un profilo studente, ma non è impostata alcuna assegnazione del curriculum.',
                    noToken: 'Nessuno studente con accesso trovato.'
                },
                errors: {
                    signInRequired: 'Accedi per visualizzare il curriculum.',
                    appIdMissing: 'ID app mancante.',
                    loadFailed: 'Impossibile caricare i dati del curriculum.'
                }
            }
    };
